<template>
  <div id="app">
    <link
      href="https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap"
      rel="stylesheet"
    />
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
    />
    <div class="view-container">
        <PageLoader></PageLoader>
        <router-view />
    </div>
  </div>
</template>

<style lang="scss">
body {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  font-weight: 100;
  font-family: 'Lexend Deca', sans-serif;
  background-color: #030303;
  color: white;
}
</style>

<script>
import PageLoader from "@/views/PageLoader/PageLoader.vue";

import Navigation from '@/components/Navigation/Navigation.vue';
import Home from '../src/components/Home/Home.vue';
import SkillsBorder from '@/components/SkillsBorder/SkillsBorder.vue';
import AboutMe from '@/components/AboutMe/AboutMe.vue';
import Contact from '@/components/Contact/Contact.vue';
import Footer from '@/components/Footer/Footer.vue';
import Projects from '@/components/Projects/Projects.vue';

export default {
  name: 'App',
  components: {
    PageLoader,
    Navigation,
    Home,
    SkillsBorder,
    AboutMe,
    Contact,
    Footer,
    Projects,
  },
};
</script>
